module.exports = __webpack_public_path__ + "static/media/phone_basket_mobile_x2.c3f14dbe.png";